import { Link } from "react-router-dom";
import { hasRole, NoDataFound } from "../../../components/Utils";
import Loader from "../../../components/common/Loader";

const InsightCard = ({ title, data, loading, emptyIcon, emptyTitle, emptyDesc, gradient, linkTo, actionTitle, actionSubtitle, patternType = "wave" }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div
        className="card text-white h-100"
        style={{
          background: gradient,
          borderRadius: "16px",
          height: "280px",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 6px 16px rgba(207, 32, 48, 0.25)",
          border: "none"
        }}
      >
        {/* Subtle Background SVG Patterns */}
        {patternType === "wave" && (
          <svg width="200" height="150" viewBox="0 0 200 150" style={{ position: "absolute", top: 0, right: 0, zIndex: 0, opacity: 0.8 }}>
            <path d="M 200 0 L 200 150 C 150 150 100 100 0 0 Z" fill="rgba(255, 255, 255, 0.05)" />
            <path d="M 200 0 L 200 80 C 160 80 120 40 50 0 Z" fill="rgba(255, 255, 255, 0.08)" />
          </svg>
        )}
        {patternType === "circles" && (
          <svg width="200" height="200" viewBox="0 0 200 200" style={{ position: "absolute", top: -50, right: -20, zIndex: 0, opacity: 0.8 }}>
            <circle cx="100" cy="100" r="100" fill="rgba(255, 255, 255, 0.03)" />
            <circle cx="100" cy="100" r="70" fill="rgba(255, 255, 255, 0.05)" />
            <circle cx="100" cy="100" r="40" fill="rgba(255, 255, 255, 0.08)" />
          </svg>
        )}
        {patternType === "diamonds" && (
          <svg width="180" height="180" viewBox="0 0 180 180" style={{ position: "absolute", top: -30, right: -10, zIndex: 0, opacity: 0.8 }}>
            <polygon points="90,0 180,90 90,180 0,90" fill="rgba(255, 255, 255, 0.03)" />
            <polygon points="90,30 150,90 90,150 30,90" fill="rgba(255, 255, 255, 0.05)" />
            <polygon points="90,60 120,90 90,120 60,90" fill="rgba(255, 255, 255, 0.08)" />
          </svg>
        )}

        <div className="card-body d-flex flex-column" style={{ position: "relative", zIndex: 1, padding: "1.5rem" }}>
          <h6 className="text-white mb-4" style={{ fontWeight: "600", fontSize: "1.05rem", opacity: 0.9 }}>{title}</h6>
          
          {loading ? (
            <Loader loading={loading} />
          ) : data?.length > 0 ? (
            <div className="d-flex flex-column flex-grow-1">
              <div className="avatar-group d-flex align-items-center justify-content-start mt-2 mb-4 flex-wrap">
                {data.slice(0, 5).map((user, i) => (
                  <div
                    key={i}
                    className="avatar avatar-md pull-up"
                    title={`${user?.name || 'Member'}`}
                    style={{
                      border: "2px solid rgba(255,255,255,0.5)",
                      borderRadius: "50%",
                      marginLeft: i !== 0 ? "-12px" : "0",
                      width: "42px",
                      height: "42px",
                    }}
                  >
                    <img
                      src={user?.thumb_profile_image || user?.profile_image || "/profile-default.png"}
                      alt="Avatar"
                      className="rounded-circle bg-white"
                      style={{ objectFit: "cover", width: "100%", height: "100%" }}
                    />
                  </div>
                ))}
                {data.length > 5 && (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      border: "2px solid rgba(255,255,255,0.5)",
                      borderRadius: "50%",
                      width: "42px",
                      height: "42px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      marginLeft: "-12px",
                      zIndex: 10,
                    }}
                  >
                    <span className="fw-bold text-white fs-6">
                      +{data.length - 5}
                    </span>
                  </div>
                )}
              </div>
              
              <p
                style={{
                  color: "#ffd54f",
                  fontWeight: "600",
                  marginBottom: "4px",
                  fontSize: "0.9rem",
                }}
              >
                {data.length} {actionSubtitle}
              </p>
              <h5 className="text-white mb-3" style={{ fontWeight: "700", fontSize: "1.3rem" }}>
                {actionTitle}
              </h5>
              
              <Link to={linkTo} className="d-flex align-items-center text-decoration-none mt-auto align-self-end" style={{ backgroundColor: "rgba(255,255,255,0.25)", color: "#ffffff", padding: "8px 16px", borderRadius: "8px", backdropFilter: "blur(4px)", transition: "0.2s" }}>
                <span className="fw-semibold me-2 d-none d-sm-block" style={{ fontSize: "0.85rem" }}>
                  View Reports
                </span>
                <i className="bx bx-right-arrow-alt" style={{ fontSize: "1.2rem" }}></i>
              </Link>
            </div>
          ) : (
            <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center h-100 mt-2">
              <div style={{ fontSize: "3rem", marginBottom: "15px" }}>{emptyIcon}</div>
              <h5 style={{ color: "#ffffff", fontWeight: "700", marginBottom: "8px" }}>{emptyTitle}</h5>
              <p className="mb-0" style={{ color: "rgba(255,255,255,0.85)", fontSize: "0.85rem", lineHeight: "1.5" }}>
                {emptyDesc}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const PendingListsTables = ({ data, loading, hasPermission }) => {
  return (
    <>
      {hasPermission("dashboard-meeting-fees-pending-list-view") && (
        <InsightCard 
          title="Pending Meeting Fees"
          data={data?.weeklyFeesPendingList}
          loading={loading}
          emptyIcon="🎉"
          emptyTitle="All Fees Collected!"
          emptyDesc="Great job! There are no pending payments for this week."
          gradient="linear-gradient(to right, #CF2030, #B71C2A)"
          linkTo="/reports/fees"
          actionSubtitle={data?.weeklyFeesPendingList?.length === 1 ? "Member Pending" : "Members Pending"}
          actionTitle="Follow Up on Payments!"
          patternType="circles"
        />
      )}
      {hasPermission("dashboard-weekly-meeting-not-attended-list-view") && (
        <InsightCard 
          title="Meetings Absentees List"
          data={data?.weeklyMeetingPendingList}
          loading={loading}
          emptyIcon="🌟"
          emptyTitle="All Attending!"
          emptyDesc="Everyone is present. Excellent attendance this week!"
          gradient="linear-gradient(to right, #CF2030, #B71C2A)"
          linkTo="/reports/attendance"
          actionSubtitle={data?.weeklyMeetingPendingList?.length === 1 ? "Member Absent" : "Members Absent"}
          actionTitle="Review Attendance!"
        />
      )}
    </>
  );
};

export default PendingListsTables;
